export default [
  {
    path: '/checklist/:id',
    name: 'Checklist',
    component: () => import('./Checklist'),
    meta: {
      domain: 'Checklist',
      sidebar: false,
      icon: 'youtube_searched_for',
      routerBack: '/ambiente',
      title: 'Checklist',
    },
  },
];



// WEBPACK FOOTER //
// ./src/app/Checklist/ChecklistRouter.js